module.exports = __webpack_public_path__ + "img/landing-page.34e89627.png";